import styled from 'styled-components';
import { Modal } from '@workramp/ui';

export const FullScreenModal = styled(Modal)`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 0;
  max-width: 100vh;
  max-height: 100vh;
`;
